module.exports = __webpack_public_path__ + "static/media/KN.6819c37b.svg";